import React, { useEffect, useState } from "react";
import {
  TableRow,
  TableCell,
  Collapse,
  Box,
  Typography,
  Grid,
  Paper,
  Link,
  Button,
  makeStyles,
  TextField,
  InputAdornment,
  CircularProgress,
} from "@material-ui/core";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import CustomButton from "./CusomButton";
import Dropzone from "react-dropzone";
import PublishIcon from "@material-ui/icons/Publish";
import FileViewer from "./FileViewer";
import { appUrl } from "../../../../../utils/config";
import axios from "axios";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { DESTROY_BACKDROP, OPEN_BACKDROP } from "../../../containers/actions/types";
import { presentDate } from "../functionalComponents/dataFormatFunctions";
import jwtDecode from 'jwt-decode';
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "16px",
    border: "1px solid #ddd",
  },
  fileLink: {
    display: "flex",
    alignItems: "center",
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  remarks: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  divider: {
    borderTop: "1px solid #ddd",
    margin: theme.spacing(2, 0),
  },
  button: {
    backgroundColor: "#FF9677",
    color: "#fff",
    marginTop: theme.spacing(1),
    "&:hover": {
      backgroundColor: "#FF9677",
    },
  },
}));

// const supportingFiles = [
//   {
//     fileName: "supporting_data.pdf",
//     fileLink: "path/to/supporting_data.pdf",
//     lastUpdatedDate: "2024-09-27 07:43:30",
//   },
// ];

const DocumnetCollapsibleRow = (props) => {
  const { open, projectData, deliverablesData, row, workItemDetails, handleSuccessDialog } = props;
  const classes = useStyles();
  const dispatch = useDispatch();

  const [versionCount, setVersionCount] = useState(null);
  const [latestFile, setLatestFile] = useState(null);
  const [latestCMOFile, setLatestCMOFile] = useState(null);

  const tokenData = jwtDecode(localStorage.getItem('authToken'));

  //   const versionCount = cdmoFileDetails.length;
  //   const latestFile = sponsorFileDetails[sponsorFileDetails.length - 1];
  const [error, setError] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [cdmoFileDetails, setCdmoFileDetails] = useState([]);
  const [sponsorFileDetails, setSponsorFileDetails] = useState([]);
  const [supportingFiles, setSupportingFileDetails] = useState([]);
  const [sponsorSupportingFile, setSponsorSupportingFile] = useState([])
  const [approveClicked, setApproveClicked] = useState(false);
  const [boFiles, setBOFiles] = useState([]);
    const [recordsFound, setRecordsFound] = useState(true);
    const [cmoFiles, setCMOFiles] = useState([]);
    const [supportingFileUpload, setSupportingFileUpload] = useState([]);

  const handleApproveClick = () => {
    setApproveClicked(true);
  };

  useEffect(() => {
    let url = null;

    const data = {
      collabrixWorkItemID: row.collabrixWorkItemID,
      collabrixExceptionID: null,
      sponsorOrgID: deliverablesData.sponsorOrgID,
      cdmoOrgID: deliverablesData.cdmoOrgID,
    };
    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchDocumentDetails`,
        data
      )
      .then((res) => {
        if (res.data.status) {
          if (
            res.data.data.cdmoFileDetails.length === 0 &&
            res.data.data.sponsorFileDetails.length === 0
          ) {
            setRecordsFound(false);
          }
          const supportingFilteredFiles = res.data.data.cdmoFileDetails.filter(
            (file) => file.fileType === "supporting_file"
          );

          setSupportingFileDetails(supportingFilteredFiles);
          const cdmoScientificFilteredFiles =
            res.data.data.cdmoFileDetails.filter(
              (file) => file.fileType === "scientific_file"
            );
          setCdmoFileDetails(cdmoScientificFilteredFiles);

          setLatestCMOFile(
            cdmoScientificFilteredFiles[cdmoScientificFilteredFiles.length - 1]
          );

          const sponsorScientificFilteredFiles =
            res.data.data.sponsorFileDetails.filter(
              (file) => file.fileType === "scientific_file"
            );

          setSponsorFileDetails(sponsorScientificFilteredFiles);

          const sponsorSupportingFilteredFiles = res.data.data.sponsorFileDetails.filter(
            (file) => file.fileType === "supporting_file"
          );

          setSponsorSupportingFile(sponsorSupportingFilteredFiles)
          setVersionCount(res.data.data.cdmoFileDetails.length);
          setLatestFile(
            sponsorScientificFilteredFiles[
              sponsorScientificFilteredFiles.length - 1
            ]
          );
          setIsLoading(false);
        } else {
          setIsLoading(false);
          setError(true);
        }
      })
      .catch((err) => {
        //console.log(err);
        setIsLoading(false);
        // setError("Something went wrong. Please try again.");
        setError(true);
      });

    return () => {
      window.URL.revokeObjectURL(url);
    };
  }, []);

  const handleFileClick = (file) => {
    // Set the clicked file in the state to open the dialog
    setSelectedFile(file);
    setDialogOpen(true); // Open the dialog when a file is clicked
  };

  const handleCloseDialog = () => {
    setDialogOpen(false); // Close the dialog
  };

  const [remarks, setRemarks] = useState("");
  const [qaRemarks, setQARemarks] = useState("");

  const handleRemarksChange = (event) => {
    setRemarks(event.target.value);
    };

    const handleFileUpload = (files) => {
        files.forEach((file) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onabort = () => console.log("file reading was aborted");
          reader.onerror = () => console.log("file reading has failed");
          reader.onload = () => {
            let fileObject = {
              name: file.name,
              data: reader.result,
              customFileType: "buffer",
              schrockenFileID: "",
              schrockenCustomFileID: "",
              customFileHash: "",
              };
              if (localStorage.collabType !== "Pharma Co") {
                setCMOFiles([...cmoFiles, fileObject]);
              } else {
                  setBOFiles([...boFiles, fileObject])
              }
            
          };
        });
    };
    
    const handleSupportingFileUpload = (files) => {
        files.forEach((file) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onabort = () => console.log("file reading was aborted");
          reader.onerror = () => console.log("file reading has failed");
          reader.onload = () => {
            let fileObject = {
              name: file.name,
              data: reader.result,
              customFileType: "buffer",
              schrockenFileID: "",
              schrockenCustomFileID: "",
              customFileHash: "",
            };
            setSupportingFileUpload([...supportingFileUpload, fileObject]);
          };
        });
      };
    
    
    const handleFileDelete = (index, supportingFile) => {
        if (supportingFile) { 
            const edit_newFiles = supportingFileUpload.filter((file, i) => i !== index);
            setSupportingFileUpload(edit_newFiles);
        }else if (localStorage.collabType !== "Pharma Co") {
            const edit_newFiles = cmoFiles.filter((file, i) => i !== index);
            setCMOFiles(edit_newFiles);
        } else {
            const edit_newFiles = boFiles.filter((file, i) => i !== index);
            setBOFiles(edit_newFiles);
        }
      };
    
      const handleUploadFile = (type) => {
        if (localStorage.collabType !== "Pharma Co") {
          let data = {
            fileName: type === "supporting_file" ? supportingFileUpload[0].name : cmoFiles[0].name,
            organizationName:
              localStorage.collabType !== "Pharma Co"
                ? deliverablesData.cdmoOrgName
                : deliverablesData.sponsorOrgName,
            docType: type,
            data: {
              sponsorOrgID: deliverablesData.sponsorOrgID,
              cdmoOrgID: deliverablesData.cdmoOrgID,
              collabrixWorkItemID: row.collabrixWorkItemID,
              eventID: "",
              uploadRemarks: remarks,
              qaRemarks: "",
              qaDecision: "",
              qaDecisionBy: "",
              qaDecisionDate: "",
              versionNumber: latestCMOFile
                ? String(latestCMOFile.versionNumber + 1)
                : "1",
              orgID:
                localStorage.collabType !== "Pharma Co"
                  ? deliverablesData.cdmoOrgID
                  : deliverablesData.sponsorOrgID,
            },
            fileData: type === "supporting_file" ? supportingFileUpload[0].data : cmoFiles[0].data,
          };
          //console.log(data);
          dispatch({
            type: OPEN_BACKDROP,
          });
    
          // setTimeout(() => {
          //   dispatch({
          //     type: DESTROY_BACKDROP,
          //   });
          //   handleSuccessDialog('documentUploadedSuccess',data)
          //     setIsLoading(true);
          //     handleCallDocumentAPI()
          // },[3000])
          axios
            .post(
              `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/addDocuments`,
              data
            )
            .then((res) => {
              dispatch({
                type: DESTROY_BACKDROP,
              });
              if (res.data.success) {
                handleSuccessDialog("documentUploadedSuccess");
                setIsLoading(true);
                // handleCallDocumentAPI();
              } else {
                setIsLoading(false);
                setError(true);
              }
            })
            .catch((err) => {
              dispatch({
                type: DESTROY_BACKDROP,
              });
              //console.log(err);
              setIsLoading(false);
              // setError("Something went wrong. Please try again.");
              setError(true);
            });
          }
          if (localStorage.collabType === "Pharma Co") {
            let data = {
              fileName: type === "supporting_file" ? supportingFileUpload[0].name : boFiles[0].name,
              organizationName:
                localStorage.collabType !== "Pharma Co"
                  ? deliverablesData.cdmoOrgName
                  : deliverablesData.sponsorOrgName,
              docType: type,
              data: {
                sponsorOrgID: deliverablesData.sponsorOrgID,
                cdmoOrgID: deliverablesData.cdmoOrgID,
                collabrixWorkItemID: row.collabrixWorkItemID,
                eventID: "",
                uploadRemarks: remarks,
                qaRemarks: "",
                qaDecision: "",
                qaDecisionBy: "",
                qaDecisionDate: "",
                versionNumber: latestFile
                  ? String(latestFile.versionNumber + 1)
                  : "1",
                orgID:
                  localStorage.collabType !== "Pharma Co"
                    ? deliverablesData.cdmoOrgID
                    : deliverablesData.sponsorOrgID,
              },
              fileData: type === "supporting_file" ? supportingFileUpload[0].data : boFiles[0].data,
            };
            //console.log(data);
            dispatch({
              type: OPEN_BACKDROP,
            });
      
            // setTimeout(() => {
            //   dispatch({
            //     type: DESTROY_BACKDROP,
            //   });
            //   handleSuccessDialog('documentUploadedSuccess',data)
            //     setIsLoading(true);
            //     handleCallDocumentAPI()
            // },[3000])
            axios
              .post(
                `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/addDocuments`,
                data
              )
              .then((res) => {
                dispatch({
                  type: DESTROY_BACKDROP,
                });
                if (res.data.success) {
                  handleSuccessDialog("documentUploadedSuccess");
                  setIsLoading(true);
                //   handleCallDocumentAPI();
                } else {
                  setIsLoading(false);
                  setError(true);
                }
              })
              .catch((err) => {
                dispatch({
                  type: DESTROY_BACKDROP,
                });
                //console.log(err);
                setIsLoading(false);
                // setError("Something went wrong. Please try again.");
                setError(true);
              });
          }
      };

  const profileDetails = useSelector((state) => state.user.userDetails || {});

  const handleCMOApproveRejectClick = (qaDecision, sequenceNumber, row) => {
    if (latestCMOFile) {
      let data = {
        ...latestCMOFile,
        projectName: deliverablesData.projectName,
          sponsorOrgID: deliverablesData.sponsorOrgID,
          cdmoOrgID: deliverablesData.cdmoOrgID,
        qaDecision: qaDecision,
        activeOrderId:sequenceNumber,
        approvalDataQAandSME: latestCMOFile.approvalDataQAandSME.map((val) => {
          if (sequenceNumber === val.sequenceNumber) {
            return {
              ...val,
              decision: qaDecision,
              remarks: remarks
            }
          } else {
            return val;
          }
        })
        };
      //console.log(data);
      if (row.eSignatureRequired) {
        handleSuccessDialog("verifyElectronicSignature", data);
      } else {
        dispatch({
          type: OPEN_BACKDROP,
        });
         const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/workflow/${qaDecision === 'Approved' ? 'approval':'reject'}`
        // console.log(url)
        // console.log(data)
        axios
            .post(
              url,
              data
            )
            .then((res) => {
              dispatch({
                type: DESTROY_BACKDROP,
              });
              if (res.data.status) {
                if (qaDecision === 'Approved') {
                  handleSuccessDialog("documentApproved");
                } else {
                  handleSuccessDialog("documentRejected")
                }
              } else {
                dispatch({
                  type: DESTROY_BACKDROP,
                });
                setError(true)
              }
            })
            .catch((err) => {
              dispatch({
                type: DESTROY_BACKDROP,
              });
              //console.log(err);
              setError(true)
            });
      }
      
      // dispatch({
      //   type: OPEN_BACKDROP,
      // });
      // setTimeout(() => {
      //   dispatch({
      //     type: DESTROY_BACKDROP,
      //   });
      //   handleSuccessDialog("verifyElectronicSignature", data);
      // }, [3000]);
    }
    };
    
  return (
    <>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            {isLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center", // Horizontally center the CircularProgress
                  alignItems: "center", // Vertically center the CircularProgress
                  height: "100px", // Optional: Set a height to vertically center the loader
                }}
              >
                <CircularProgress />
              </div>
            ) : error ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center", // Horizontally center the CircularProgress
                  alignItems: "center", // Vertically center the CircularProgress
                  height: "100px", // Optional: Set a height to vertically center the loader
                  border: "2px solid #FF0000",
                  backgroundColor: "#FFF0F0",
                  width: "100%",
                }}
              >
                <Typography style={{ textAlign: "center" }}>
                  Something went wrong. Please try again.
                </Typography>
              </div>
            ) : (
              <Box margin={1}>
                <Grid container spacing={3}>
                <Grid item xs={6}>
                    <Typography variant="h6">
                      {deliverablesData.cdmoOrgName}
                    </Typography>
                    <Paper elevation={2} className={classes.paper}>
                      {/* {cdmoFileDetails.map((file, index) => (
                        
                      ))} */}
                      {/* {localStorage.collabType !== "Pharma Co" && latestCMOFile && (
                        <React.Fragment>
                          <Grid container spacing={3}>
                            <Grid item xs={4}>
                              <Typography variant="subtitle1">
                                Version {latestCMOFile.versionNumber}
                              </Typography>
                              <Typography variant="body2" color="textSecondary">
                                {moment(latestCMOFile.lastUpdatedDate).format(
                                  "(YYYY-MM-DD HH:mm:ss)"
                                )}
                              </Typography>
                            </Grid>

                            <Grid item xs={8} className={classes.fileLink}>
                              <PublishIcon className={classes.icon} />
                              <Link
                                href={latestCMOFile.fileLink}
                                target="_blank"
                                rel="noopener"
                                color="secondary"
                                style={{ cursor: "pointer" }}
                                onClick={(e) => {
                                  e.preventDefault(); // Prevent default link action
                                  handleFileClick(latestCMOFile); // Trigger the state change to open the component
                                }}
                              >
                                {latestCMOFile.fileName}
                              </Link>
                            </Grid>
                          </Grid>

                          <Grid container spacing={3}>
                            <Grid item xs={4}>
                              <Typography
                                variant="body2"
                                className={classes.remarks}
                              >
                                Upload Remarks
                              </Typography>
                            </Grid>
                            <Grid item xs={8}>
                              <Typography
                                variant="body2"
                                className={classes.remarks}
                              >
                                {latestCMOFile.uploadRemarks
                                  ? latestCMOFile.uploadRemarks
                                  : "-NA-"}
                              </Typography>
                            </Grid>
                          </Grid>
                        </React.Fragment>
                                                  )} */}
                                                  
                                                  {cdmoFileDetails.map((file, index) => (
                        <React.Fragment key={index}>
                          <Grid container spacing={3}>
                            {/* Version and Date (Left-aligned) */}
                            <Grid item xs={4}>
                              <Typography variant="subtitle1">
                                Round {file.versionNumber}
                              </Typography>
                              <Typography variant="body2" color="textSecondary">
                                {moment(file.lastUpdatedDate).format(
                                  "(YYYY-MM-DD HH:mm:ss)"
                                )}
                              </Typography>
                            </Grid>

                            {/* File Name (Right-aligned) */}
                            <Grid item xs={8} className={classes.fileLink}>
                              <PublishIcon className={classes.icon} />
                              <Link
                                href={file.fileLink}
                                target="_blank"
                                rel="noopener"
                                color="secondary"
                                style={{ cursor: "pointer" }}
                                onClick={(e) => {
                                  e.preventDefault(); // Prevent default link action
                                  handleFileClick(file); // Trigger the state change to open the component
                                }}
                              >
                                {file.fileName}
                              </Link>
                            </Grid>
                          </Grid>

                          {/* Remarks (Upload or Resubmission) */}
                          <Grid container spacing={3}>
                            <Grid item xs={4}>
                                <Typography
                                  variant="body2"
                                  className={classes.remarks}
                                >
                                  Upload Remarks
                                </Typography>
                            </Grid>
                            <Grid item xs={8}>
                              <Typography
                                variant="body2"
                                className={classes.remarks}
                              >
                                {file.uploadRemarks
                                  ? file.uploadRemarks
                                  : "-NA-"}
                              </Typography>
                            </Grid>
                          </Grid>
                        </React.Fragment>
                      ))}

                          {localStorage.collabType !== "Pharma Co" &&
                            <Grid
                              container
                              spacing={3}
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <Grid item xs={4}>
                                <CustomButton
                                  disabled={cmoFiles.length === 0}
                                  color="#F26336" // Custom orange background
                                  hoverColor="#D8542E" // Darker orange on hover
                                  textColor="#fff" // Explicitly set white text color
                                  fontSize="0.275rem"
                                  onClick={() =>
                                    handleUploadFile("scientific_file")
                                  }
                                >
                                  {`Upload Round ${latestCMOFile
                                      ? latestCMOFile.versionNumber + 1
                                      : 1
                                    }`}
                                </CustomButton>
                              </Grid>

                              {/* Drag & Drop file area */}

                              {cmoFiles.length === 0 ? (
                                <Grid item xs={8}>
                                  <Box>
                                    <Dropzone
                                      // disabled
                                      onDrop={(files) => {
                                        handleFileUpload(files);
                                      }}
                                      accept=".pdf"
                                    >
                                      {({ getRootProps, getInputProps }) => (
                                        <div
                                          {...getRootProps({
                                            className: "dropzone",
                                            onDrop: (event) =>
                                              event.preventDefault(),
                                          })}
                                          // className={classes.files}
                                          style={{
                                            border: "1px solid #707070",
                                            display: "flex",
                                            alignItems: "center", // Align content vertically
                                            justifyContent: "space-between", // Space out text and icon
                                            //   padding: "10px",
                                          }}
                                        >
                                          <input {...getInputProps()} />

                                          {/* Text for the dropzone */}
                                          <Typography
                                            variant="body2"
                                            style={{
                                              cursor: "pointer",
                                              paddingLeft: "10px",
                                            }}
                                          >
                                            Drag &amp; drop or click here to
                                            upload files
                                          </Typography>

                                          {/* Upload icon aligned to the right */}
                                          <PublishIcon
                                            fontSize="large"
                                            style={{
                                              marginLeft: "auto", // Push icon to the right
                                              cursor: "pointer",
                                            }}
                                          />
                                        </div>
                                      )}
                                    </Dropzone>
                                  <Typography variant="caption">
                                    <span style={{ color: "red" }}>Note:</span>{" "}
                                    Only PDF files are allowed
                                  </Typography>
                                  </Box>
                                </Grid>
                              ) : (
                                <Grid item xs={8} className={classes.fileLink}>
                                  {cmoFiles.map((file, i) => (
                                    <>
                                      <PublishIcon className={classes.icon} />
                                      <Link
                                        // href={file.fileLink}
                                        target="_blank"
                                        color="secondary"
                                        style={{ cursor: "pointer" }}
                                      // onClick={(e) => {
                                      //   e.preventDefault(); // Prevent default link action
                                      //   handleFileClick(file); // Trigger the state change to open the component
                                      // }}
                                      >
                                        {file.name}
                                      </Link>
                                      <CloseIcon
                                        fontSize="small"
                                        color="error"
                                        style={{
                                          paddingLeft: "0.5rem",
                                          paddingTop: "0.5rem",
                                          cursor: "pointer",
                                          width: "19px",
                                        }}
                                        onClick={() => handleFileDelete(i)}
                                      />
                                    </>
                                  ))}
                                </Grid>
                              )}
                            </Grid>
                        
                          }
                          {localStorage.collabType !== "Pharma Co" &&
                          
                            <Grid
                              container
                              spacing={3}
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <Grid item xs={4}>
                                <Typography
                                  variant="body2"
                                  className={classes.remarks}
                                >
                                  Upload Remarks
                                </Typography>
                              </Grid>
                              <Grid item xs={8}>
                                <TextField
                                  placeholder="Enter remarks here"
                                  variant="outlined"
                                  fullWidth
                                  margin="normal"
                                  multiline
                                  size="small"
                                  value={remarks} // Bind the state to the TextField value
                                  onChange={handleRemarksChange} // Trigger the handler on change
                                />
                              </Grid>
                            </Grid>
                          }

                      <Grid container spacing={3}>
                        <Grid item xs={12}>
                          <Grid
                            style={{
                              display: "flex",
                              justifyContent: "end",
                              paddingTop: "14px",
                            }}
                          >
                            <CustomButton
                              color="#F26336" // Custom orange background
                              hoverColor="#D8542E" // Darker orange on hover
                              textColor="#fff" // Explicitly set white text color
                              disabled
                              //   disabled={
                              //     localStorage.collabType === "Pharma Co"
                              //       ? true
                              //       : false
                              //   }
                            >
                              Remind BMS Team
                            </CustomButton>
                          </Grid>
                        </Grid>
                      </Grid>

                          {((localStorage.collabType !== "Pharma Co") || (localStorage.collabType === "Pharma Co" && supportingFiles.length !== 0)) &&
                            <Grid container spacing={3}>
                            <Grid xs={12}>
                              <div className={classes.divider}></div>
                            </Grid>
                          </Grid>}

                      {
                        localStorage.collabType !== "Pharma Co" && (
                            <Grid
                            container
                            spacing={3}
                          >
                            <Grid item xs={4}>
                              <CustomButton
                                disabled={supportingFileUpload.length === 0}
                                color="#F26336" // Custom orange background
                                hoverColor="#D8542E" // Darker orange on hover
                                textColor="#fff" // Explicitly set white text color
                                fontSize="0.275rem"
                                onClick={() =>
                                  handleUploadFile("supporting_file")
                                }
                              >
                                {`Upload Supporting File`}
                              </CustomButton>
                            </Grid>

                            {/* Drag & Drop file area */}

                            {supportingFileUpload.length === 0 ? (
                              <Grid item xs={8}>
                                <Box>
                                  <Dropzone
                                    // disabled
                                    onDrop={(files) => {
                                      handleSupportingFileUpload(files);
                                    }}
                                    accept=".pdf"
                                  >
                                    {({ getRootProps, getInputProps }) => (
                                      <div
                                        {...getRootProps({
                                          className: "dropzone",
                                          onDrop: (event) =>
                                            event.preventDefault(),
                                        })}
                                        // className={classes.files}
                                        style={{
                                          border: "1px solid #707070",
                                          display: "flex",
                                          alignItems: "center", // Align content vertically
                                          justifyContent: "space-between", // Space out text and icon
                                          //   padding: "10px",
                                        }}
                                      >
                                        <input {...getInputProps()} />

                                        {/* Text for the dropzone */}
                                        <Typography
                                          variant="body2"
                                          style={{
                                            cursor: "pointer",
                                            paddingLeft: "10px",
                                          }}
                                        >
                                          Drag &amp; drop or click here to
                                          upload files
                                        </Typography>

                                        {/* Upload icon aligned to the right */}
                                        <PublishIcon
                                          fontSize="large"
                                          style={{
                                            marginLeft: "auto", // Push icon to the right
                                            cursor: "pointer",
                                          }}
                                        />
                                      </div>
                                    )}
                                  </Dropzone>
                                  <Typography variant="caption">
                                    <span style={{ color: "red" }}>Note:</span>{" "}
                                    Only PDF files are allowed
                                  </Typography>
                                </Box>
                              </Grid>
                            ) : (
                              <Grid item xs={8} className={classes.fileLink}>
                                {supportingFileUpload.map((file, i) => (
                                  <>
                                    <PublishIcon className={classes.icon} />
                                    <Link
                                      // href={file.fileLink}
                                      target="_blank"
                                      color="secondary"
                                      style={{ cursor: "pointer" }}
                                      // onClick={(e) => {
                                      //   e.preventDefault(); // Prevent default link action
                                      //   handleFileClick(file); // Trigger the state change to open the component
                                      // }}
                                    >
                                      {file.name}
                                    </Link>
                                    <CloseIcon
                                      fontSize="small"
                                      color="error"
                                      style={{
                                        paddingLeft: "0.5rem",
                                        paddingTop: "0.5rem",
                                        cursor: "pointer",
                                        width: "19px",
                                      }}
                                      onClick={() => handleFileDelete(i, true)}
                                    />
                                  </>
                                ))}
                              </Grid>
                            )}
                          </Grid>
                        )}
                      {/* Supporting Files */}
                       <Grid container spacing={3}>
                                                  
                        {supportingFiles.map((file, index) => (
                          <>
                            <Grid item xs={4}>
                              <Typography
                                variant="subtitle1"
                                style={{ marginTop: "20px" }} // Added margin for better spacing
                              >
                                {index === 0 ? "Supporting Files" : ""}
                              </Typography>
                            </Grid>

                            <Grid
                              container
                              item
                              xs={8}
                              key={index}
                              alignItems="flex-start"
                              className={classes.fileLink}
                              style={{ marginTop: "20px" }} // Added margin for better spacing
                            >
                              {/* File Icon and Name */}
                              <Grid container alignItems="center">
                                <PublishIcon className={classes.icon} />
                                <Link
                                  href={file.fileLink}
                                  target="_blank"
                                  rel="noopener"
                                  style={{
                                    marginRight: "8px",
                                    cursor: "pointer",
                                  }}
                                  color="secondary"
                                  onClick={(e) => {
                                    e.preventDefault(); // Prevent default link action
                                    handleFileClick(file); // Trigger the state change to open the component
                                  }}
                                >
                                  {file.fileName}
                                </Link>
                              </Grid>

                              {/* Date below the file name */}
                              <Grid item xs={12}>
                                <Typography
                                  variant="body2"
                                  color="textSecondary"
                                >
                                  {moment(file.lastUpdatedDate).format(
                                    "(YYYY-MM-DD HH:mm:ss)"
                                  )}
                                </Typography>
                              </Grid>
                            </Grid>
                          </>
                        ))}
                      </Grid>
                    </Paper>
                  </Grid>

                      
                        <Grid item xs={6}>
                          <Typography variant="h6">
                            {deliverablesData.sponsorOrgName}
                          </Typography>
                          <Paper elevation={2} className={classes.paper}>
                            {sponsorFileDetails.map((file, index) => (
                        <React.Fragment key={index}>
                          <Grid container spacing={3}>
                            <Grid item xs={5}>
                              <Typography variant="subtitle1">
                              Response to Round {file.versionNumber}
                              </Typography>
                              <Typography variant="body2" color="textSecondary">
                                {moment(file.lastUpdatedDate).format(
                                  "(YYYY-MM-DD HH:mm:ss)"
                                )}
                              </Typography>
                            </Grid>

                            <Grid item xs={7} className={classes.fileLink}>
                              <PublishIcon className={classes.icon} />
                              <Link
                                href={file.fileLink}
                                target="_blank"
                                rel="noopener"
                                color="secondary"
                                style={{ cursor: "pointer" }}
                                onClick={(e) => {
                                  e.preventDefault(); // Prevent default link action
                                  handleFileClick(file); // Trigger the state change to open the component
                                }}
                              >
                                {file.fileName}
                              </Link>
                            </Grid>
                          </Grid>

                          <Grid container spacing={3}>
                            <Grid item xs={5}>
                              <Typography
                                variant="body2"
                                className={classes.remarks}
                              >
                                Upload Remarks
                              </Typography>
                            </Grid>
                            <Grid item xs={7}>
                              <Typography
                                variant="body2"
                                className={classes.remarks}
                              >
                                {file.uploadRemarks ? file.uploadRemarks:'-NA-'}
                              </Typography>
                            </Grid>
                          </Grid>
                        </React.Fragment>
                            ))}
                          

                          {localStorage.collabType === "Pharma Co" &&
                            <Grid
                              container
                              spacing={3}
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <Grid item xs={4}>
                                <CustomButton
                                  disabled={boFiles.length === 0}
                                  color="#F26336" // Custom orange background
                                  hoverColor="#D8542E" // Darker orange on hover
                                  textColor="#fff" // Explicitly set white text color
                                  fontSize="0.275rem"
                                  onClick={() =>
                                    handleUploadFile("scientific_file")
                                  }
                                >
                                  {`Response to Round ${latestFile
                                      ? latestFile.versionNumber + 1
                                      : 1
                                    }`}
                                </CustomButton>
                              </Grid>

                              {/* Drag & Drop file area */}

                              {boFiles.length === 0 ? (
                                <Grid item xs={8}>
                                  <Box>
                                    <Dropzone
                                      // disabled
                                      onDrop={(files) => {
                                        handleFileUpload(files);
                                      }}
                                      accept=".pdf"
                                    >
                                      {({ getRootProps, getInputProps }) => (
                                        <div
                                          {...getRootProps({
                                            className: "dropzone",
                                            onDrop: (event) =>
                                              event.preventDefault(),
                                          })}
                                          // className={classes.files}
                                          style={{
                                            border: "1px solid #707070",
                                            display: "flex",
                                            alignItems: "center", // Align content vertically
                                            justifyContent: "space-between", // Space out text and icon
                                            //   padding: "10px",
                                          }}
                                        >
                                          <input {...getInputProps()} />

                                          {/* Text for the dropzone */}
                                          <Typography
                                            variant="body2"
                                            style={{
                                              cursor: "pointer",
                                              paddingLeft: "10px",
                                            }}
                                          >
                                            Drag &amp; drop or click here to
                                            upload files
                                          </Typography>

                                          {/* Upload icon aligned to the right */}
                                          <PublishIcon
                                            fontSize="large"
                                            style={{
                                              marginLeft: "auto", // Push icon to the right
                                              cursor: "pointer",
                                            }}
                                          />
                                        </div>
                                      )}
                                    </Dropzone>
                                  <Typography variant="caption">
                                    <span style={{ color: "red" }}>Note:</span>{" "}
                                    Only PDF files are allowed
                                  </Typography>
                                  </Box>
                                </Grid>
                              ) : (
                                <Grid item xs={8} className={classes.fileLink}>
                                  {boFiles.map((file, i) => (
                                    <>
                                      <PublishIcon className={classes.icon} />
                                      <Link
                                        // href={file.fileLink}
                                        target="_blank"
                                        color="secondary"
                                        style={{ cursor: "pointer" }}
                                      // onClick={(e) => {
                                      //   e.preventDefault(); // Prevent default link action
                                      //   handleFileClick(file); // Trigger the state change to open the component
                                      // }}
                                      >
                                        {file.name}
                                      </Link>
                                      <CloseIcon
                                        fontSize="small"
                                        color="error"
                                        style={{
                                          paddingLeft: "0.5rem",
                                          paddingTop: "0.5rem",
                                          cursor: "pointer",
                                          width: "19px",
                                        }}
                                        onClick={() => handleFileDelete(i)}
                                      />
                                    </>
                                  ))}
                                </Grid>
                              )}
                            </Grid>
                          }

                      {/* Approve/Reject Remarks */}
                          {localStorage.collabType === "Pharma Co" &&
                            <Grid
                              container
                              spacing={3}
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <Grid item xs={4}>
                                <Typography
                                  variant="body2"
                                  className={classes.remarks}
                                >
                                  Upload Remarks
                                </Typography>
                              </Grid>
                              <Grid item xs={8}>
                                <TextField
                                  placeholder="Enter remarks here"
                                  variant="outlined"
                                  fullWidth
                                  margin="normal"
                                  multiline
                                  size="small"
                                  value={remarks} // Bind the state to the TextField value
                                  onChange={handleRemarksChange} // Trigger the handler on change
                                />
                              </Grid>
                            </Grid>
                          }

                      {/* Add "Remind Sponsor Team" button */}
                      <Grid container spacing={3}>
                        <Grid item xs={12}>
                          <Grid
                            style={{
                              display: "flex",
                              justifyContent: "end",
                              paddingTop: "14px",
                            }}
                          >
                            <CustomButton
                              color="#F26336" // Custom orange background
                              hoverColor="#D8542E" // Darker orange on hover
                              textColor="#fff" // Explicitly set white text color
                              disabled
                              //   disabled={
                              //     localStorage.collabType === "Pharma Co"
                              //       ? true
                              //       : false
                              //   }
                            >
                              Remind CMO Team
                            </CustomButton>
                          </Grid>
                        </Grid>
                      </Grid>

                          {((localStorage.collabType === "Pharma Co") || (localStorage.collabType !== "Pharma Co" && sponsorSupportingFile.length !== 0)) &&
                            <Grid container spacing={3}>
                            <Grid xs={12}>
                              <div className={classes.divider}></div>
                            </Grid>
                          </Grid>}

                      {localStorage.collabType === "Pharma Co" && (
                            <Grid
                            container
                            spacing={3}
                          >
                            <Grid item xs={4}>
                              <CustomButton
                                disabled={supportingFileUpload.length === 0}
                                color="#F26336" // Custom orange background
                                hoverColor="#D8542E" // Darker orange on hover
                                textColor="#fff" // Explicitly set white text color
                                fontSize="0.275rem"
                                onClick={() =>
                                  handleUploadFile("supporting_file")
                                }
                              >
                                {`Upload Supporting File`}
                              </CustomButton>
                            </Grid>

                            {/* Drag & Drop file area */}

                            {supportingFileUpload.length === 0 ? (
                              <Grid item xs={8}>
                                <Box>
                                  <Dropzone
                                    // disabled
                                    onDrop={(files) => {
                                      handleSupportingFileUpload(files);
                                    }}
                                    accept=".pdf"
                                  >
                                    {({ getRootProps, getInputProps }) => (
                                      <div
                                        {...getRootProps({
                                          className: "dropzone",
                                          onDrop: (event) =>
                                            event.preventDefault(),
                                        })}
                                        // className={classes.files}
                                        style={{
                                          border: "1px solid #707070",
                                          display: "flex",
                                          alignItems: "center", // Align content vertically
                                          justifyContent: "space-between", // Space out text and icon
                                          //   padding: "10px",
                                        }}
                                      >
                                        <input {...getInputProps()} />

                                        {/* Text for the dropzone */}
                                        <Typography
                                          variant="body2"
                                          style={{
                                            cursor: "pointer",
                                            paddingLeft: "10px",
                                          }}
                                        >
                                          Drag &amp; drop or click here to
                                          upload files
                                        </Typography>

                                        {/* Upload icon aligned to the right */}
                                        <PublishIcon
                                          fontSize="large"
                                          style={{
                                            marginLeft: "auto", // Push icon to the right
                                            cursor: "pointer",
                                          }}
                                        />
                                      </div>
                                    )}
                                  </Dropzone>
                                  <Typography variant="caption">
                                    <span style={{ color: "red" }}>Note:</span>{" "}
                                    Only PDF files are allowed
                                  </Typography>
                                </Box>
                              </Grid>
                            ) : (
                              <Grid item xs={8} className={classes.fileLink}>
                                {supportingFileUpload.map((file, i) => (
                                  <>
                                    <PublishIcon className={classes.icon} />
                                    <Link
                                      // href={file.fileLink}
                                      target="_blank"
                                      color="secondary"
                                      style={{ cursor: "pointer" }}
                                      // onClick={(e) => {
                                      //   e.preventDefault(); // Prevent default link action
                                      //   handleFileClick(file); // Trigger the state change to open the component
                                      // }}
                                    >
                                      {file.name}
                                    </Link>
                                    <CloseIcon
                                      fontSize="small"
                                      color="error"
                                      style={{
                                        paddingLeft: "0.5rem",
                                        paddingTop: "0.5rem",
                                        cursor: "pointer",
                                        width: "19px",
                                      }}
                                      onClick={() => handleFileDelete(i, true)}
                                    />
                                  </>
                                ))}
                              </Grid>
                            )}
                          </Grid>
                        )}
                      {/* Supporting Files */}
                       <Grid container spacing={3}>
                                                  
                        {sponsorSupportingFile.map((file, index) => (
                          <>
                            <Grid item xs={4}>
                              <Typography
                                variant="subtitle1"
                                style={{ marginTop: "20px" }} // Added margin for better spacing
                              >
                                {index === 0 ? "Supporting Files" : ""}
                              </Typography>
                            </Grid>

                            <Grid
                              container
                              item
                              xs={8}
                              key={index}
                              alignItems="flex-start"
                              className={classes.fileLink}
                              style={{ marginTop: "20px" }} // Added margin for better spacing
                            >
                              {/* File Icon and Name */}
                              <Grid container alignItems="center">
                                <PublishIcon className={classes.icon} />
                                <Link
                                  href={file.fileLink}
                                  target="_blank"
                                  rel="noopener"
                                  style={{
                                    marginRight: "8px",
                                    cursor: "pointer",
                                  }}
                                  color="secondary"
                                  onClick={(e) => {
                                    e.preventDefault(); // Prevent default link action
                                    handleFileClick(file); // Trigger the state change to open the component
                                  }}
                                >
                                  {file.fileName}
                                </Link>
                              </Grid>

                              {/* Date below the file name */}
                              <Grid item xs={12}>
                                <Typography
                                  variant="body2"
                                  color="textSecondary"
                                >
                                  {moment(file.lastUpdatedDate).format(
                                    "(YYYY-MM-DD HH:mm:ss)"
                                  )}
                                </Typography>
                              </Grid>
                            </Grid>
                          </>
                        ))}
                      </Grid>
                        

                            
                         
                      
                          
                            
                          </Paper>
                        </Grid>
                </Grid>
              </Box>
            )}
          </Collapse>
        </TableCell>
      </TableRow>

      {isDialogOpen && (
        <FileViewer
          openFileView={isDialogOpen}
          file={selectedFile}
          handleFileViewClose={handleCloseDialog}
          row={row}
          deliverablesData={deliverablesData}
          workItemDetails={workItemDetails}
          sponsorFileDetails={sponsorFileDetails}
          cdmoFileDetails={cdmoFileDetails}
          supportingFiles={supportingFiles}
          sponsorOrgID={deliverablesData?.sponsorOrgID}
          cdmoOrgID={deliverablesData?.cdmoOrgID}
        />
      )}
    </>
  );
};

export default DocumnetCollapsibleRow;
